import CiqaPicturesWall from './ciqaPicturesWall';
import Modal from './Modal'
import Upload from './Upload'
import ciqaFileCatetory from './ciqaFileCatetory'
import ciqaAttachModal from './ciqaAttachModal'
import ciqaFileGrid from './ciqaFileGrid'
import NoApproval from './NoApproval';
import PassApproval from './PassApproval';
import ShowApproval from './ShowApproval';

export default {

    CiqaPicturesWall,
    Modal,
    Upload,
    NoApproval,
    PassApproval,
    ShowApproval,
    ciqaFileCatetory,
    ciqaAttachModal,
    ciqaFileGrid
}